import { getReporter } from './core/tracerProvider';

export function reportMetrics(metrics) {
  try {
    const reporter = getReporter();
    if (Array.isArray(metrics)) {
      reporter.addMetrics(metrics);
    } else {
      reporter.addMetric(metrics);
    }
  } catch (error) {
    console.error('[@shopeepay/reporter] Error reporting metrics:', error);
  }
}
